import { Box, Button, Checkbox, Collapse, Container, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemText, MenuItem, Modal, Select, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as yup from 'yup';
import RtlProvider from "../../../Components/RtlProvider";
import customtheme from "../../../themes";
import { RiDeleteBin5Fill } from "react-icons/ri";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { TbEdit, TbPlaylistAdd } from "react-icons/tb";
import EnumMapper from "../../../EnumMapper";
import AddPackageEvent from "./AddPackageEvent";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import packageApi from "../../../api/packageApi";
import { ContextNotification, severitys } from "../../../App";
import EditPackageEvent from "./EditPackageEvents";
import { MdCalculate, MdCheck, MdClose, MdExpandLess, MdExpandMore, MdList, MdOutlineSearch, MdReviews } from "react-icons/md";


const EditPackageDetail = ({ AddEditType, PackageDetail, AddPackageDetail, Refresh }) => {

    const { open, setOpen } = useContext(ContextNotification);
    const [isloading, setIsloading] = useState(false);
    const [title, setTitle] = useState(null);
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showError, setShowError] = useState(false);
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });

 

    useEffect(() => {
       resetForm();
    }, [PackageDetail]);

    const GetPackageEvents = (PackageDetailid) => {

        setIsloading(true);
        packageApi.GetPackageEventsByPackageDetailID(PackageDetailid).then((res) => {
            if (res.data.success) {
                const eventdata = res.data.data.map((itm, index) => {
                    return (
                        {
                            "id": itm.id,
                            "index": index,
                            "value": {
                                "description": itm.description,
                                "eventTypeId": itm.eventType,
                                "eventTypeText": itm.eventTypeTitle,
                                "fromCity": itm.fromCity,
                                "fromCityText": itm.fromCityTitle,
                                "toCity": itm.toCity,
                                "toCityText": itm.toCityTitle,
                                "startT": itm.start,
                                "endT": itm.end,
                            }
                        }
                    );

                })
                setEvents(eventdata);
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setIsloading(false));
    }
    const HandleChangeTitle = (event) => {
        setTitle(event.target.value);
    }
    const onSubmit = () => {

    }
    const updatePackageDetailTitle = () => {
        setIsloading(true);
        packageApi.EditPackageDetailtitle(PackageDetail.id, title).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setIsloading(false));
    }
    const AddDetail = () => {
        let pevents = null;
        if (events?.length > 0)
            pevents = events?.map((e) => { return e.value });
        if (title.trim() === '') {
            setShowError(true);
        }
        else {
            const detaildata = {
                "title": title,
                "events": pevents,
            }
            AddPackageDetail(detaildata);
            resetForm();
        }

    }
    const resetForm = () => {
        setShowError(false);
        setTitle('');
        setEvents([]);
        setSelectedEvent(null);
        if (PackageDetail) {
            setTitle(PackageDetail.title);
            GetPackageEvents(PackageDetail.id);

        }
    }

    /////event
    const [showAddEvent, setShowAddEvent] = useState(false);
        const [showEditEvent, setShowEditEvent] = useState(false);
    const AddNewEvent = (eventData) => {
        var maxIndex = events.length > 0 ? Math.max(...events.map(a => { return a.index })) : 0;
        const newitem = {
            "index": maxIndex + 1,
            "value": eventData
        }
        setEvents([...events, newitem]);
        setShowAddEvent(false);
    }


    const RemoveEvent = (index) => {
        if (AddEditType === EnumMapper.AddEditMode.Add) {
            const a = events.filter((a) => a.index !== index);
            setEvents(a);
        }        
    }
    const HandleEditEvent = () => {
        if (showEditEvent) {
            setShowEditEvent(false);
        }
        else {
            setShowEditEvent(true);
        }
    }
        const HandleAddEvent = () => {
        if (showAddEvent) {
            setShowAddEvent(false);         
        }
        else {
            setShowAddEvent(true);
        }

    }
 

    return (
        <>
            <ThemeProvider theme={customtheme(customization)}>
                <Container maxWidth={false} style={{ padding: 20 }}  >
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <RtlProvider>
                            <Grid container spacing={1} >

                                <Grid item md={12} xs={12}>
                                    <TextField label="عنوان مرحله سفر" margin="normal" focused={true} value={title} onChange={(e) => HandleChangeTitle(e)} sx={{ width: '60%' }}></TextField>

                                    {(AddEditType === EnumMapper.AddEditMode.Add)&&(title!=='') && <Tooltip title="افزودن رویداد سفر"><IconButton edge="end" sx={{ mt: 3 }} aria-label="افزودن رویداد سفر" onClick={() => { HandleAddEvent(); }}>
                                        <TbPlaylistAdd color='#4a148c' size={24} />
                                    </IconButton>
                                    </Tooltip>}

                                    {(AddEditType === EnumMapper.AddEditMode.Edit)&&(title!=='') && <Tooltip title="ویرایش عنوان مرحله سفر"><IconButton disabled={isloading} edge="end" sx={{ mt: 3 }} aria-label="ویرایش عنوان" onClick={() => { updatePackageDetailTitle(); }}>
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                        < TbEdit color='#4a148c' size={24} />
                                    </IconButton>
                                    </Tooltip>}
                                    
                                    {(AddEditType === EnumMapper.AddEditMode.Edit)&&(title!=='') && <Tooltip title="ویرایش رویدادهای سفر"><IconButton disabled={isloading} edge="end" sx={{ mt: 3 }} aria-label="ویرایش رویدادهای سفر" onClick={() => { HandleEditEvent(); }}>
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                       {(showEditEvent)?<MdExpandLess  color='#4a148c' size={24} />:<MdExpandMore  color='#4a148c' size={24} />} 
                                    </IconButton>
                                    </Tooltip>}

                                </Grid>
                            </Grid>
                            {(showAddEvent)&&<AddPackageEvent Event={selectedEvent} AddPackageEvent={(data) => AddNewEvent(data)}/> }
                            {(AddEditType === EnumMapper.AddEditMode.Add)&&(events?.length > 0) &&
                                <Box style={{overflowX: 'auto', display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                                    <List sx={{ width: '100%' }} style={{overflowX: 'auto'}}>
                                        {events?.sort((a,b)=>a.index>=b.index?1:-1).map((itm) => {
                                            return (
                                                <ListItem key={itm.index} >
                                                    <Grid container spacing={2}>
                                                        <Grid item md={1} sx={1}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.index+'-'} />
                                                        </Grid>
                                                        <Grid item md={2} sx={10}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.description} />
                                                        </Grid>
                                                        <Grid item md={2} sx={12}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.eventTypeText} />
                                                        </Grid>
                                                        <Grid item md={1.5} sx={4}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.startT?' ساعت ' + itm.value.startT:''} />
                                                        </Grid>
                                                        <Grid item md={1} sx={4}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.fromCityText?' شهر ' + itm.value.fromCityText:''} />
                                                        </Grid>
                                                        <Grid item md={1.5} sx={4}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.endT?' ساعت ' + itm.value.endT:itm.value.endT} />
                                                        </Grid>
                                                        <Grid item md={1} sx={4}>
                                                            <ListItemText sx={{ ml: 1 }} primary={itm.value.toCityText?' شهر ' + itm.value.toCityText:''} />
                                                        </Grid>

                                                        
                                                        {(AddEditType === EnumMapper.AddEditMode.Edit) &&
                                                            <Grid item md={2} sx={4}>
                                                                <IconButton edge="end" aria-label="ویرایش" onClick={() => { HandleEditEvent(itm.id) }}>
                                                                    <TbEdit  color='#4a148c'/>
                                                                </IconButton>
                                                            </Grid>
                                                        }
                                                        <Grid item md={1} sx={2}>
                                                            <IconButton edge="end" aria-label="حذف" onClick={() => { RemoveEvent(itm.index, itm.id) }}>
                                                                <RiDeleteBin5Fill color= '#C7253E' />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                    

                                                </ListItem>
                                            )
                                        })
                                        }
                                    </List>
                                </Box>}
                                   {(showEditEvent)&&<EditPackageEvent Events={events} Refresh={resetForm} /> }
                            {(AddEditType === EnumMapper.AddEditMode.Add) && (events?.length > 0) && <>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{
                                        fontSize: "16px",
                                        width: "10rem",
                                        height: "3rem",
                                    }}
                                    sx={{ m: 1 }}
                                    onClick={() => { AddDetail() }}
                                >
ویرایش                                </Button>
                                {(showError) && <p className="error">{' عنوان مرحله سفر را وارد کنید'}</p>}

                            </>}
                        

                        </RtlProvider>
                    </form>
                 
                </Container>
            </ThemeProvider>
        </>

    );
}
export default EditPackageDetail;